export default __webpack_public_path__ + "static/media/checkup.bb1559cb.gif";